var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('m-basic-form',[_c('m-map-show')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }